var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHospital(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 154,
    height: 124,
    viewBox: "0 0 154 124",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#777",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    stroke: "#FFF",
    strokeWidth: 2.4,
    d: "M149.115 116.286h-17.307V44.857c0-1.578-1.292-2.857-2.885-2.857H74.115v-8.571c0-1.578-1.291-2.858-2.884-2.858h-5.77V4.857C65.462 3.28 64.172 2 62.578 2H33.73c-1.593 0-2.885 1.28-2.885 2.857v25.714h-5.77c-1.592 0-2.884 1.28-2.884 2.858v82.857H4.885c-1.594 0-2.885 1.279-2.885 2.857C2 120.72 3.291 122 4.885 122h144.23c1.594 0 2.885-1.28 2.885-2.857 0-1.578-1.291-2.857-2.885-2.857zM36.615 7.714h23.077v22.857H36.615V7.714zm-8.653 28.572h40.384v80H27.962v-80zm66.346 80v-11.429h11.538v11.429H94.308zm17.307 0V102c0-1.578-1.291-2.857-2.884-2.857H91.423c-1.593 0-2.885 1.279-2.885 2.857v14.286H74.115V47.714h51.923v68.572h-14.423z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.038 10.571H45.27v5.715H39.5V22h5.77v5.714h5.768V22h5.77v-5.714h-5.77z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    stroke: "#FFF",
    strokeWidth: 2.4,
    d: "M59.692 42H36.615c-1.593 0-2.884 1.28-2.884 2.857v11.429c0 1.578 1.291 2.857 2.884 2.857h23.077c1.593 0 2.885-1.28 2.885-2.857V44.857c0-1.578-1.292-2.857-2.885-2.857zm-2.884 11.429H39.5v-5.715h17.308v5.715zM59.692 64.857H36.615c-1.593 0-2.884 1.28-2.884 2.857v11.429c0 1.578 1.291 2.857 2.884 2.857h23.077c1.593 0 2.885-1.28 2.885-2.857V67.714c0-1.578-1.292-2.857-2.885-2.857zm-2.884 11.429H39.5V70.57h17.308v5.715zM59.692 87.714H36.615c-1.593 0-2.884 1.28-2.884 2.857V102c0 1.578 1.291 2.857 2.884 2.857h23.077c1.593 0 2.885-1.279 2.885-2.857V90.571c0-1.578-1.292-2.857-2.885-2.857zm-2.884 11.429H39.5v-5.714h17.308v5.714zM117.385 53.429H82.769c-1.593 0-2.884 1.279-2.884 2.857v11.428c0 1.578 1.291 2.857 2.884 2.857h34.616c1.593 0 2.884-1.279 2.884-2.857V56.286c0-1.578-1.291-2.857-2.884-2.857zM114.5 64.857H85.654v-5.714H114.5v5.714zM117.385 76.286H82.769c-1.593 0-2.884 1.279-2.884 2.857V90.57c0 1.578 1.291 2.858 2.884 2.858h34.616c1.593 0 2.884-1.28 2.884-2.858V79.143c0-1.578-1.291-2.857-2.884-2.857zM114.5 87.714H85.654V82H114.5v5.714z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospital);
export default __webpack_public_path__ + "static/media/hospital.5b0b04175c3c6e2bcc05256e04688d25.svg";
export { ForwardRef as ReactComponent };